import axios, { AxiosResponse } from 'axios';
import { setupInterceptorsTo } from './Interceptors';

import { AuthRequest, CreateApiKeyRequest, RefreshTokenRequest } from '@/models/AuthModels';
import { PagedRequest } from '@/models/CommonModels';

/* DEV */
// import config from '../../appsettings.dev.json';

/* PROD */
const appsettings = await fetch('/appsettings.json');
const config = await appsettings.json();

const env = window.__ENV__ ?? null;

const BASE_URL = (env != undefined && env?.BASE_URL != undefined && env?.BASE_URL != '' ? env?.BASE_URL : config.api.baseUrl) + '/v1';

const apiClient = setupInterceptorsTo(
  axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-api-key': API_KEY,
    },
  })
);

export default {
  //#region  Auth
  login(data: AuthRequest): Promise<AxiosResponse> {
    return apiClient.post('/login', data);
  },

  register(data: AuthRequest): Promise<AxiosResponse> {
    return apiClient.post('/register', data);
  },

  refreshLogin(data: RefreshTokenRequest) {
    return apiClient.post('/login/refresh', data);
  },

  logout(data: RefreshTokenRequest): Promise<AxiosResponse> {
    return apiClient.post('/logout', data);
  },
  //#endregion

  //#region API Keys
  getAllApiKeys(): Promise<AxiosResponse> {
    return apiClient.get('/apikeys');
  },

  createApiKey(data: CreateApiKeyRequest): Promise<AxiosResponse> {
    return apiClient.post('/apikey', data);
  },

  deleteApiKey(id: number): Promise<AxiosResponse> {
    return apiClient.delete(`/apikey/${id}`);
  },
  //#endregion

  //#region Database
  isDatabaseUpToDate(): Promise<AxiosResponse> {
    return apiClient.get('/database/status');
  },

  updateDatabase(): Promise<AxiosResponse> {
    return apiClient.get('/database/update');
  },
  //#endregion

  //#region FehlerLogs
  getFehlerLogPage(data: PagedRequest): Promise<AxiosResponse> {
    return apiClient.get(
      `/fehlerlogs/page?pageIndex=${data.page}&pageSize=${data.pageSize}&sortBy=${data.sortBy}&sortDirection=${data.sortDirection}&filter=${data.filter}`
    );
  },
  //#endregion

  //#region Maschinen
  getAllMaschinen(): Promise<AxiosResponse> {
    return apiClient.get('/maschinen');
  },
  //#endregion

  //#region Paletten
  getAllPaletten(date: Date): Promise<AxiosResponse> {
    // Format date as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    return apiClient.get(`/paletten/datum/${formattedDate}`);
  },
  //#endregion

  //#region Produktionsauftraege
  // getAllProduktionsauftraege(): Promise<AxiosResponse> {
  //   return apiClient.get('/produktionsauftraege');
  // },

  getAllProduktionsauftraegeDatum(date: Date): Promise<AxiosResponse> {
    // Format date as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    return apiClient.get(`/produktionsauftraege/datum/${formattedDate}`);
  },
  //#endregion

  //#region User
  getAllUsers(): Promise<AxiosResponse> {
    return apiClient.get('/users');
  },

  deleteUser(id: number): Promise<AxiosResponse> {
    return apiClient.delete(`/user/${id}`);
  },
  //#endregion
};
